import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'SimpleTextMarker',
  props: {
    text: null
  },
  setup(__props: any) {



return { __sfc: true, }
}

})